import PropTypes from 'prop-types';
import React from 'react';

import { ContentContainer } from '@/design-system/atoms/ContentContainer';

import styles from './SkipLink.module.scss';

const SkipLink = (props) => {
    const { targetId, linkLabel } = props;

    const handleClick = (e) => {
        const target = document.getElementById(targetId);
        if (!target) {
            e.preventDefault();
            const main = document.querySelector('main');
            if (main) {
                if (!main.hasAttribute('tabindex')) {
                    main.setAttribute('tabindex', '-1');
                }
                main.focus();
            }
        }
    };

    return (
        linkLabel &&
        linkLabel !== '' && (
            <ContentContainer className={styles[`skipLink__spacing`]}>
                <a className={styles.skipLink} href={`#${targetId}`} onClick={handleClick}>
                    {linkLabel}
                </a>
            </ContentContainer>
        )
    );
};

SkipLink.propTypes = {
    /**
     * The id of the element to skip to
     */
    targetId: PropTypes.string,
    /**
     * Visible label of the skip link
     */
    linkLabel: PropTypes.string,
};

SkipLink.defaultProps = {
    targetId: 'main-content',
};

export default SkipLink;
